<div class="rtl relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
    <div class="rounded-t border-b-2 mb-0 px-6 py-6">
      <div class="flex justify-between">
        <h6 class="text-primary text-lg font-bold w-6/12 text-start"> حساب کاربری </h6>
        <h6 class="text-primary text-lg w-6/12 text-end" >
           <a class="cursor-pointer" (click)="back()"> بازگشت </a> </h6>
  
      </div>
    </div>
    <div class="flex-auto px-4 lg:px-10 py-10 pt-0">
      <form>
        <h6 class="text-blueGray-400 text-base mt-3 mb-6 font-bold">
          اطلاعات شخصی
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-sm font-bold my-4" > جنسیت
                </label>
                <div class="flex items-center m-4">
                  <input id="inline-3-radio" type="radio" [(ngModel)]="userInfo.gender" [value]="genderType.notSet" name="inline-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300" [checked]="userInfo.gender==genderType.notSet">
                  <label for="inline-3-radio" class="mx-2 text-sm font-medium text-gray-900 "> مشخص نشده
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="inline-radio" type="radio" [(ngModel)]="userInfo.gender" [value]="genderType.male" name="inline-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300" [checked]="userInfo.gender==genderType.male">
                  <label for="inline-radio" class="mx-2 text-sm font-medium text-gray-900 "> آقا
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="inline-2-radio" type="radio" [(ngModel)]="userInfo.gender" [value]="genderType.female" name="inline-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300" [checked]="userInfo.gender==genderType.female">
                  <label for="inline-2-radio" class="mx-2 text-sm font-medium text-gray-900 "> خانم
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                نام
              </label>
              <input type="text" [(ngModel)]="userInfo.firstName" name="firstName"
                class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm border-gray-300 w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                نام خانوادگی
              </label>
              <input type="text" [(ngModel)]="userInfo.lastName" name="lastName"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2">
                شماره تلفن
              </label>
              <input type="text" [(ngModel)]="userInfo.mobile" name="mobile"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                کد ملی
              </label>
              <input type="text" [(ngModel)]="userInfo.idNo" name="idNo"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-60 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                سال تولد
              </label>
              <input type="number" [(ngModel)]="userInfo.birthDate" name="birthDate"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
          <div class="w-full lg:w-6/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                نوع بیمه
              </label>
              <select type="text" [(ngModel)]="userInfo.lastAllergy" name="inshurance"
                  class="border-gray-300 p-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full rtl" >
                  <option value="1"> بیمه ندارم </option>
                  <option value="2"> بیمه تامین اجتماعی </option>
                  <option value="3"> بیمه نیروهای مسلح </option>
                  <option value="4"> بیمه سلامت </option>
                  <option value="5"> سایر بیمه ها </option>
              </select>
            </div>
          </div>
        </div>
  
        <hr class="mt-6 border-b-1 border-blueGray-300" />
  
        <h6 class="text-blueGray-400 text-base mt-3 mb-6 font-bold">
          پرونده بیمار
        </h6>
        <div class="flex flex-wrap">
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <label class=" text-blueGray-600 text-sm font-bold my-4" > آیا بیماری زمینه
                ای دارید؟
              </label>
              <div class="flex">
                <div *ngFor="let dis of allDisease;let i=index;" class="flex items-center m-2">
                    <input [id]="'desease-'+i" type="checkbox" value="" [checked]="selectedDiseases.includes(dis.id)" 
                      class="w-4 h-4 text-primary bg-gray-100 border-gray-300" disabled>
                    <label [for]="'desease-'+i" class="mx-1 text-sm font-medium text-gray-900 "> {{dis.titleFa}}
                    </label>
                </div>
                <!-- <div class="flex items-center m-2">
                  <input id="inline-radio1" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio1" class="mx-1 text-sm font-medium text-gray-900 "> مشکل خاصی
                    ندارم </label>
                </div> -->
                <!-- <div class="flex items-center m-2">
                  <input id="inline-radio3" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio3" class="mx-1 text-sm font-medium text-gray-900 "> کم کاری
                    تیروئید </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio4" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio4" class="mx-1 text-sm font-medium text-gray-900 "> پر کاری
                    تیروئید </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio7" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio7" class="mx-1 text-sm font-medium text-gray-900 "> چربی خون
                  </label>
                </div> -->
              </div>
              <!-- <div class="flex">
                <div class="flex items-center m-2">
                  <input id="inline-radio5" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio5" class="mx-1 text-sm font-medium text-gray-900 "> فشار خون
                    بالا </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio6" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio6" class="mx-1 text-sm font-medium text-gray-900 "> فشار خون
                    پایین </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio8" type="checkbox" value="" name="disease-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio8" class="mx-1 text-sm font-medium text-gray-900 "> بیماری
                    روماتیسمی </label>
                </div>
              </div> -->
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-sm font-bold my-4" > سابقه بیماری قلبی دارید؟
                </label>
                <div class="flex items-center m-4">
                  <input id="radio1" type="radio" name="heart-disease" [checked]="userInfo.isActiveLastHeart" (change)="userInfo.isActiveLastHeart=!userInfo.isActiveLastHeart"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio1" class="mx-2 text-sm font-medium text-gray-900 "> بله
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="radio2" type="radio" name="heart-disease"
                    [checked]="!userInfo.isActiveLastHeart" (change)="userInfo.isActiveLastHeart=!userInfo.isActiveLastHeart"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio2" class="mx-2 text-sm font-medium text-gray-900 "> خیر
                  </label>
                </div>
              </div>
              <input type="text" [(ngModel)]="userInfo.lastHeart" name="lastHeart" [disabled]="!userInfo.isActiveLastHeart" [ngStyle]="{'cursor':!userInfo.isActiveLastHeart?'not-allowed':'auto'}"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <div class="flex">
                <label class="uppercase text-blueGray-600 text-sm font-bold my-4" > سابقه بیماری ریوی دارید؟
                </label>
                <div class="flex items-center m-4">
                  <input id="radio3" type="radio" [checked]="userInfo.isActiveLastLung" (change)="userInfo.isActiveLastLung=!userInfo.isActiveLastLung" name="lung-disease" 
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio3" class="mx-2 text-sm font-medium text-gray-900 "> بله
                  </label>
                </div>
                <div class="flex items-center m-4">
                  <input id="radio4" type="radio" [checked]="!userInfo.isActiveLastLung" (change)="userInfo.isActiveLastLung=!userInfo.isActiveLastLung" name="lung-disease" 
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="radio4" class="mx-2 text-sm font-medium text-gray-900 "> خیر
                  </label>
                </div>
              </div>
              <input type="text" [(ngModel)]="userInfo.lastLung" name="lastLung" [disabled]="!userInfo.isActiveLastLung" [ngStyle]="{'cursor':!userInfo.isActiveLastLung?'not-allowed':'auto'}"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                آیا بیماری دیگری دارید؟ (شرح دهید)
              </label>
              <textarea type="text" [(ngModel)]="userInfo.another_Diseases" name="another_Diseases"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"
                rows="4">  </textarea>
            </div>
          </div>
  
          <div class="w-full p-2">
            <div class="relative w-full mb-3">
              <label class="uppercase text-blueGray-600 text-sm font-bold my-4" > 
                آیا سابقه جراحی دارید؟ 
              </label>
              <div class="flex">
                
                <div *ngFor="let dis of allSurgery;let i=index;"  class="flex items-center m-2">
                    <input [id]="'surgery-'+i" type="checkbox" value="" [checked]="selectedDiseases.includes(dis.id)" 
                      class="w-4 h-4 text-primary bg-gray-100 border-gray-300" disabled>
                    <label [for]="'surgery-'+i" class="mx-1 text-sm font-medium text-gray-900 "> {{dis.titleFa}}
                    </label>
                </div>
                  <!-- <div class="flex items-center m-2">
                    <input id="inline-radio-1" type="checkbox" value="" name="surgery-radio-group"
                      class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                    <label for="inline-radio-1" class="mx-1 text-sm font-medium text-gray-900 ">  سابقه جراحی دارم  </label>
                  </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-2" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-2" class="mx-1 text-sm font-medium text-gray-900 "> جراحی قلب </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-3" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-3" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن کیسه صفرا </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-4" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-4" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن رحم  </label>
                </div>
                <div class="flex items-center m-2">
                  <input id="inline-radio-5" type="checkbox" value="" name="surgery-radio-group"
                    class="w-4 h-4 text-primary bg-gray-100 border-gray-300">
                  <label for="inline-radio-5" class="mx-1 text-sm font-medium text-gray-900 "> برداشتن روده </label>
                </div> -->
              </div>
            </div>
          </div>
  
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                آیا جراحی دیگری انجام داده اید؟
              </label>
              <input type="text" [(ngModel)]="userInfo.another_surgery" name="another_surgery"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                داروهای در حال مصرف           
               </label>
              <input type="text" [(ngModel)]="userInfo.lastDrug" name="lastDrug"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full" />
            </div>
          </div>
  
          <div class="w-full lg:w-12/12 p-2">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-sm font-bold mb-2" >
                حساسیت ها           
               </label>
              <input type="text" [(ngModel)]="userInfo.lastAllergy" name="lastAllergy"
                class="border-gray-300 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 rounded text-sm w-full"/>
            </div>
          </div>
  
          <!-- <div class="w-full lg:w-12/12 p-2">
            <div class="flex justify-end w-full mb-3">
              <button (click)="updateUserInfo()" type="button" class="bg-primary text-white active:bg-green-900 font-bold uppercase text-lg px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1">
                 تایید اطلاعات 
                </button>
            </div>
          </div> -->
  
        </div>
  
      </form>
    </div>
  </div>